<template>
    <ValidationObserver v-slot="{ invalid, pristine }" slim ref="observer">
        <v-form @keypress.enter.prevent="submit" @submit.prevent="submit">
            <v-row>
                <v-col>
                    FIGYELEM: ha nem múltál el 16 éves, kérjük, hogy törvényes képviselőddel együtt végezd el a regisztrációs folyamatot!<br />
                    Felhívjuk a figyelmed, hogy amennyiben nem járulsz hozzá a kép és hangfelvétel készítéséhez, úgy az online programokra kamera és mikrofon bekapcsolása nélkül jelentkezz be!
                </v-col>
            </v-row>

            <v-row>
                <v-col>

                    <ValidationProvider v-slot="{ errors }" name="E-mail cím" rules="required|max:255|email">
                        <v-text-field type="email" autocomplete="email" label="E-mail cím" v-model="form.email" :error-messages="errors" autofocus/>
                    </ValidationProvider>

                    <ValidationProvider v-slot="{ errors }" name="Vezetéknév" rules="required|max:255">
                        <v-text-field type="text" autocomplete="family-name" label="Vezetéknév" v-model="form.first_name" required
                                      :error-messages="errors"/>
                    </ValidationProvider>

                    <ValidationProvider v-slot="{ errors }" name="Keresztnév" rules="required|max:255">
                        <v-text-field type="text" autocomplete="given-name" label="Keresztnév" v-model="form.last_name" required
                                      :error-messages="errors"/>
                    </ValidationProvider>

                    <ValidationProvider v-slot="{ errors }" name="Jelszó" vid="password" rules="required|min:6|max:100|password">
                        <v-text-field type="password" autocomplete="new-password" label="Jelszó" v-model="form.password" :error-messages="errors"/>
                    </ValidationProvider>

                    <ValidationProvider v-slot="{ errors }" name="Jelszó" vid="passwordRepeat" rules="required|confirmed:password">
                        <v-text-field type="password" autocomplete="new-password" label="Jelszó még egyszer" v-model="form.password_confirmation"
                                      :error-messages="errors"/>
                    </ValidationProvider>

                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <template>
                        <ValidationProvider v-slot="{ errors }" name="mező" rules="required">
                            <v-checkbox :error-messages="errors" v-model="form.check1" value="1" outlined dense  hint="" id="checkbox_1" persistent-hint="">
                                <template v-slot:label>
                                    <div>
                                        Személyes adataim kezeléséről tájékoztatást kaptam, a
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <a
                                                        target="_blank"
                                                        href="/documents/Kutatok_Ejszakaja_Adatkezelesi_tajekoztato.pdf"
                                                        @click.stop
                                                        v-on="on"
                                                >
                                                    tájékoztatást
                                                </a>
                                            </template>
                                            új lapon nyílik
                                        </v-tooltip>
                                        elfogadom.
                                    </div>
                                </template>
                            </v-checkbox>
                        </ValidationProvider>
                    </template>
                    <template>
                        <v-checkbox v-model="form.check2" value="1" outlined dense hint="opcionális" id="checkbox_2" persistent-hint="">
                            <template v-slot:label>
                                <div>
                                    Kérem és hozzájárulok ahhoz, hogy számomra a Kutatók Éjszakája rendezvényről küldjenek hírlevelet, és ennek érdekében
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }"><a
                                                    target="_blank"
                                                    href="https://kutatokejszakaja.hu/wp-content/uploads/2022/08/hirlevel_tajekoztato_kutatokejszakaja.pdf"
                                                    @click.stop
                                                    v-on="on"
                                            >adataimat kezeljék</a></template>
                                        új lapon nyílik
                                    </v-tooltip>.</div></template>
                        </v-checkbox>
                    </template>
                    <template>
                        <v-checkbox v-model="form.check3" value="1" outlined dense hint="opcionális" id="checkbox_3" persistent-hint="">
                            <template v-slot:label>
                                <div>
                                    Kérem és hozzájárulok ahhoz, hogy számomra más hasonló (tudományos) rendezvényről küldjenek hírlevelet, és ennek érdekében
                                    <v-tooltip bottom><template v-slot:activator="{ on }"><a
                                                    target="_blank"
                                                    href="https://kutatokejszakaja.hu/wp-content/uploads/2022/08/hirlevel_tajekoztato_kutatokejszakaja.pdf"
                                                    @click.stop
                                                    v-on="on"
                                            >adataimat kezeljék</a></template>
                                        új lapon nyílik
                                    </v-tooltip>.</div></template>
                        </v-checkbox>

                    </template>
<!--                    <template>-->
<!--                        <v-checkbox v-model="form.check4" value="1" outlined dense label="Hozzájárulok ahhoz, hogy  a Kutatók Éjszakája rendezvényen rólam kép- és vagy hangfelvételek készüljenek és ezek a rendezvény és annak célja népszerűsítése érdekében felhasználásra kerüljenek." hint="opcionális" id="'checkbox_4'" persistent-hint="" />-->
<!--                    </template>-->
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="8">
                </v-col>
                <v-col cols="4">
                    <v-btn submit color="primary" absolute @click="submit" :disabled="loading || invalid">
                        Regisztráció
                    </v-btn>
                </v-col>

            </v-row>
        </v-form>

        <v-snackbar v-model="success" color="success">
            Sikeres regisztráció
        </v-snackbar>
    </ValidationObserver>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                success: false,
                checkedBoxes: [1, 2, 3, 4],
                gdprCheckboxes: [
                    {
                        "id":"accept1",
                        "text": "Személyes adataim kezeléséről tájékoztatást kaptam, a tájékoztatást elfogadom.",
                        "rules": "required",
                        "hint": ""
                    }, {
                        "id":"accept2",
                        "text": "Kérem és hozzájárulok ahhoz, hogy számomra a Kutatók Éjszakája rendezvényről küldjenek hírlevelet, és ennek érdekében adataimat kezeljék. ",
                        "rules": "",
                        "hint": "Opcionális"
                    }, {
                        "id":"accept3",
                        "text": "Kérem és hozzájárulok ahhoz, hogy számomra más hasonló (tudományos) rendezvényről küldjenek hírlevelet, és ennek érdekében adataimat kezeljék.",
                        "rules": "",
                        "hint": "Opcionális"
                    }, {
                        "id":"accept4",
                        "text": "Hozzájárulok ahhoz, hogy  a Kutatók Éjszakája rendezvényen rólam kép- és vagy hangfelvételek készüljenek és ezek a rendezvény és annak célja népszerűsítése érdekében felhasználásra kerüljenek.",
                        "rules": "",
                        "hint": "Opcionális",
                    }
                ],

            };
        },
        props: {
            prevRoute: {type: String, required: false},
            form:{Object, default:()=>{return {}}}
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (!isValid) {
                    return false;
                }

                this.loading = true;
                axios.post('/user/register-visitor', this.form)
                .then(data => {
                    if (data.status !== 200 && data.status !== 204 && data || data instanceof Error) {
                        this.error = data;
                    } else {
                        this.success = true;
                        setTimeout(() => {
                            window.location = '/user/visitor-registration-successful';
                        }, 500)
                    }
                }).catch(data => {
                    this.error = true;
                    Object.assign(this.errorItem, data.error);
                })
                .finally(() => {
                    this.loading = false;
                })
            }
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = from
            });
        }
    };
</script>
